import {Injectable} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {Router} from "@angular/router";
import { Observable  } from 'rxjs';
import { RestUrlsConfig } from "@signature-it/ngx-generic/config";
import { LanguageService } from "@signature-it/ngx-generic/services";
import {exhaustMap, take} from "rxjs/operators";
import {ILanguage} from "@signature-it/ngx-generic/interfaces";

@Injectable({
    providedIn: 'root'
})

export class EntityTreeService {

    protected getTreeUrl = `${this.config.appURL}/public/entity/tree`;
    protected getTaxonomyMenuUrl = `${this.config.appURL}/public/entity/tree/menu`;
    protected getEntityTypeRelatedUrl = `${this.config.appURL}/public/entity/get_related_entity_type`;

    constructor(
        protected http: HttpClient,
        protected config: RestUrlsConfig,
        protected router: Router,
        protected langSvc: LanguageService
    ) {}

    getTree(entity_type_var: string, node_var?: string, depth?: string) {
        return this.langSvc.getCurrentLanguage$().pipe(
            take(1),
            exhaustMap((lang: ILanguage) => {
                return this.http.get(this.getTreeUrl, { params: {
                        'entity_type_var' : entity_type_var,
                        'langId': lang.id,
                        ...(node_var && {'entity_node_var' : node_var}),
                        ...(depth && {'depth': depth})
                    }}
                )})
            );
    }

    getTreeByTaxUri(depth: number, taxonomy_uri: string, node_var?: string): Observable<any> {
        return this.langSvc.getCurrentLanguage$().pipe(
            take(1),
            exhaustMap((lang: ILanguage) => {
                return this.http.get(this.getTreeUrl, { params: {
                        'taxonomy_uri' : taxonomy_uri,
                        'langId': this.langSvc.CurrLang.id,
                        depth,
                        ...(node_var && {'entity_node_var' : node_var})
                    }}
                )})
        );
    }


    getTaxonomyMenu(entityTypeVar: string, nodeEntityVar?: string, depth?: string): Observable<any> {
        return this.langSvc.getCurrentLanguage$().pipe(
            take(1),
            exhaustMap((lang: ILanguage) => {
                return this.http.get(this.getTaxonomyMenuUrl, { params: {
                        'entity_type_var' : entityTypeVar,
                        ...(nodeEntityVar && {'node_entity_var' : nodeEntityVar}),
                        ...(depth && {'depth': depth}),
                        'langId': this.langSvc.CurrLang.id,
                    }}
                )})
        );
    }


    getEntityTypeRelated(entity_type_var: string): Observable<any> {
        return this.http.get(this.getEntityTypeRelatedUrl, { params: {
                'entity_type_var' : entity_type_var,
            }
        });
    }
}
